module.exports = __webpack_public_path__ + "static/portrait_home-d0f2b7abff1912b93c2f6e9461b0bb69.jpg";